import React from 'react'

const PartnershipBanner = () => {
    return (
        <div className='partnership-banner'>
            <div className='content'>
                <div className='title'><h1>PARTNERSHIP</h1></div>
                <div className='subtitle'><span><p>At Liberyus, we collaborate with industry leaders worldwide to deliver innovative and tailored solutions. Our partnerships are built on trust, excellence, and a shared vision to create impactful digital experiences that drive success.</p></span></div>
            </div>
        </div>
    )
}

export default PartnershipBanner
